import React from 'react';

import LockIcon from '@mui/icons-material/Lock';
import { styled } from '@mui/material/styles';
import { PageThumbnail } from '@sunwisesoftware/racking-template-core';
import PropTypes from 'prop-types';

const BORDER_WIDTH = 4;
const THUMBNAIL_HEIGHT = 148;
const THUMBNAIL_WIDTH = 118;

const PageWrapper = styled('div')`
    width: ${({ orientation }) =>
        orientation === 'portrait' ? THUMBNAIL_WIDTH : THUMBNAIL_HEIGHT}px;
    height: ${({ orientation }) =>
        orientation === 'portrait' ? THUMBNAIL_HEIGHT : THUMBNAIL_WIDTH}px;
    background-color: #fff;
    border-radius: 2px;
    border: ${BORDER_WIDTH}px solid transparent;
    cursor: pointer;
    margin: 0 auto;
    position: relative;
    z-index: 1;

    display: flex;
    align-items: center;
    justify-content: center;

    &.selected {
        border: ${BORDER_WIDTH}px solid #008dff;
    }
`;

const Dots = styled('span')`
    font-size: 50px;
    pointer-events: none;
`;

const StyledPageThumbnail = styled(PageThumbnail)`
    && {
        width: ${({ page }) =>
            (page.orientation === 'portrait'
                ? THUMBNAIL_WIDTH
                : THUMBNAIL_HEIGHT) -
            BORDER_WIDTH * 2}px;
        height: ${({ page }) =>
            (page.orientation === 'portrait'
                ? THUMBNAIL_HEIGHT
                : THUMBNAIL_WIDTH) -
            BORDER_WIDTH * 2}px;
        min-height: initial;
        min-width: initial;

        & > div {
            transform: scale(
                ${({ page }) =>
                    page.orientation === 'portrait'
                        ? (THUMBNAIL_WIDTH - BORDER_WIDTH * 2) / 778.5
                        : (THUMBNAIL_HEIGHT - BORDER_WIDTH * 2) / 1123.26},
                ${({ page }) =>
                    page.orientation === 'portrait'
                        ? (THUMBNAIL_HEIGHT - BORDER_WIDTH * 2) / 1123.26
                        : (THUMBNAIL_WIDTH - BORDER_WIDTH * 2) / 778.5}
            );
        }
    }
`;

const ItemPreviewPage = ({ handleClickSelect, page, selected }) => {
    return (
        <PageWrapper
            className={selected && 'selected'}
            onClick={handleClickSelect}
            orientation={page.orientation}
        >
            {selected && <Dots>&#183;&#183;&#183;</Dots>}
            {!selected && <StyledPageThumbnail page={page} />}
            {page.blocked === 1 && <LockIcon />}
        </PageWrapper>
    );
};

ItemPreviewPage.propTypes = {
    handleClickSelect: PropTypes.func,
    page: PropTypes.object,
    selected: PropTypes.bool,
};

export default ItemPreviewPage;
